import React, { useEffect, useState } from "react";
import { auth, firestore } from "../../db/config";
import AdminInputChatField from "./adminInputChatField";
import ListUsers from "./listUsers";
import RenderAdminMessage from "./messageComponent";

export default function MessageCover() {
  const [getUsers, setgetUsers] = useState([]);
  const [getUserId, setgetUserId] = useState("");
  const handleUserClick = (user) => {
   
    setgetUserId(user);
   
  };
  const userRandomNumber = JSON.parse(
    localStorage.getItem("persist:userNumber")
  );

  const getRendomNumber = JSON.parse(userRandomNumber.getChatClickReducer);
  const userId = getRendomNumber.user;
  const handleLogout = () => {
    auth.signOut().then(() => {
      window.location.href = "/adminPortal";
    });
  };
  useEffect(() => {
    auth.onAuthStateChanged((user) => {
     
      if (user) {
        firestore
          .collection("users")
          .doc(user.uid)
          .get()
          .then((result) => {
            console.log(result.data())
            if (!result.data().authType) {
              window.location.href = "/";
            }
          });
      } else {
        window.location.href = "/";
      }
    });
  }, []);
  return (
    <div className="row">
      <div
        className="col-3"
        style={{
          backgroundColor: "#00AAEF",
          height: "100vh",
          overflowY: "scroll",
        }}
      >
        <div
          style={{
            width: "100%",
            textAlign: "center",
            paddingTop: "20px",
            fontWeight: "700",
            color: "white",
            marginBottom: "20px",
          }}
        >
          <button
            style={{
              paddingTop: "10px",
              paddingBottom: "10px",
              paddingLeft: "10px",
              paddingRight: "10px",
              color: "white",
              background: "red",
              border: "none",
              marginRight: "10px",
              cursor: "pointer",
            }}
            onClick={handleLogout}
          >
            Logout Admin
          </button>{" "}
          Users chat List
        </div>
        <ListUsers userId={handleUserClick} />
      </div>
      <div className="col" style={{ height: "100vh" }}>
        <div style={{ height: "90vh", overflowY: "scroll" }}>
          {userId ? <RenderAdminMessage /> : ""}
        </div>
        <AdminInputChatField />
      </div>
    </div>
  );
}
